let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("410SS")).then(() => parcelRequire('aY5Ef'));